import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit } from 'redux-form/immutable';
import {
  TextField,
} from 'redux-form-material-ui';
import { Tabs, Tab } from 'material-ui/Tabs';
import Paper from 'material-ui/Paper';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

import Icon from '../Common/Icon';
import { hideDialog } from '../../actions/dialogs';
import { getDialogContextProp } from '../../reducers/helper';
import ReduxDialog from '../Common/ReduxDialog';
import Status from '../Common/Status';
import { getStageStatus, toArray, getLastStageCompletion } from '../../utils/helper';
import { editTaskRoutine } from '../../routines';

import commonStyles from '../styles';
import styles from './styles';
import NotesTable from '../NotesTable/index';

class TaskDialog extends Component {
  static propTypes = {
    job: PropTypes.object.isRequired,
    task: PropTypes.object,
    hideDialog: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  handleDiscard = () => {
    this.props.hideDialog('task');
  };

  handleSave = () => {
    this.props.onRequestClose();
  };

  handleSkipStage = (a, b, c) => {
    console.log('handleSkipStage', a, b, c);
  };

  handleCompleteStage = (a, b, c) => {
    console.log('handleSkipStage', a, b, c);
  };

  renderStages() {
    const { job, task } = this.props;

    if (!task || !job) { // } || !this.props.task.stages) {
      return null;
    }
    return (<Table selectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn style={styles.iconCol}></TableHeaderColumn>
          <TableHeaderColumn style={styles.nameCol}>Name</TableHeaderColumn>
          <TableHeaderColumn style={styles.assignedToCol}>Assigned To</TableHeaderColumn>
          <TableHeaderColumn style={styles.completedByCol}>Completed By</TableHeaderColumn>
          <TableHeaderColumn style={styles.completedAtCol}>Completed At</TableHeaderColumn>
          <TableHeaderColumn style={styles.statusCol}>Status</TableHeaderColumn>
          {/*<TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>*/}
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {job.profile.stages.map(this.renderStage)}
      </TableBody>
    </Table>);
  }

  renderStage = (stage) => {
    const { task } = this.props;
    const status = getStageStatus(task, stage);
    const completion = getLastStageCompletion(task, stage);

    return (<TableRow key={stage.id} selectable={false}>
      <TableRowColumn style={styles.iconCol}><Icon name={stage.icon || 'barcode'} style={styles.icon}/></TableRowColumn>
      <TableRowColumn style={styles.nameCol}>{stage.name}</TableRowColumn>
      <TableRowColumn style={styles.assignedToCol}>{stage.assignedTo}</TableRowColumn>
      <TableRowColumn style={styles.completedByCol}>{ completion ? completion.by.name : '' }</TableRowColumn>
      <TableRowColumn style={styles.completedAtCol}>{ completion ? moment(completion.at).format('lll') : '' }</TableRowColumn>
      <TableRowColumn style={styles.statusCol}><Status label={status.name} containerStyle={{ backgroundColor: status.color }}/></TableRowColumn>
      {/*<TableRowColumn style={styles.actionCol}>*/}
      {/*<IconButton*/}
      {/*tooltip="Complete Stage" tooltipPosition="bottom-center"*/}
      {/*onClick={() => this.handleCompleteStage(stage)}*/}
      {/*>*/}
      {/*<FontIcon className="material-icons" style={styles.completeStageIcon}>done</FontIcon>*/}
      {/*</IconButton>*/}
      {/*<IconButton tooltip="Skip Stage" tooltipPosition="bottom-center" onClick={() => this.handleSkipStage(stage)}>*/}
      {/*<FontIcon className="material-icons" style={styles.completeStageIcon}>delete</FontIcon>*/}
      {/*</IconButton>*/}
      {/*</TableRowColumn>*/}
    </TableRow>);
  };

  render() {
    const { task, dispatch } = this.props;
    // console.log('TASK', task ? task.toJS() : null);

    if (!task) {
      return null;
    }

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.handleDiscard}
      />,
      <FlatButton
        label="Save"
        primary
        onClick={() => dispatch(submit('task'))}
      />,
    ];

    return (
      <ReduxDialog
        title="Task"
        actions={actions}
        modal={false}
        name="task"
        onRequestClose={this.handleDiscard}
        autoScrollBodyContent
      >
        <form name="Task">
          <div style={styles.main}>
            <div style={styles.row}>
              <Field
                name="origin.building"
                component={TextField}
                floatingLabelText="Origin Building"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
              <Field
                name="origin.floor"
                component={TextField}
                floatingLabelText="Origin Floor"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
              <Field
                name="origin.space"
                component={TextField}
                floatingLabelText="Origin Space"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
            </div>
            <div style={styles.row}>
              <Field
                name="destination.building"
                component={TextField}
                floatingLabelText="Destination Building"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
              <Field
                name="destination.floor"
                component={TextField}
                floatingLabelText="Destination Floor"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
              <Field
                name="destination.space"
                component={TextField}
                floatingLabelText="Destination Space"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
            </div>
            <Paper style={styles.contact}>
              <Field
                name="contact.name"
                component={TextField}
                floatingLabelText="Contact Name"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
              <Field
                name="contact.mobile"
                component={TextField}
                floatingLabelText="Mobile"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
              <Field
                name="contact.email"
                component={TextField}
                floatingLabelText="Email"
                floatingLabelFixed
                fullWidth
                style={commonStyles.input}
              />
            </Paper>
            <div>
              <Tabs>
                <Tab label="Stages">
                  <div>
                    {this.renderStages()}
                  </div>
                </Tab>
                <Tab label="Notes">
                  <NotesTable notes={toArray(task.notes || {})}/>
                </Tab>
              </Tabs>
            </div>
          </div>
        </form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'task',  // a unique identifier for this form
  enableReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    const task = values;
    props.onRequestClose();
    return dispatch(editTaskRoutine.trigger(task));
  },
})(TaskDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const task = getDialogContextProp(state.get('dialogs').get('dialogs'), 'task', 'task');
  return {
    task: task ? task.toJS() : null,
    job: state.get('jobs').get('job').toJS(),
    initialValues: task,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/TaskDialog/index.js